import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { MicInvComb } from '../models/mic-inv-comb';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MicInvCombService {


  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  salvar(micInvComb: MicInvComb) {
    return this.http.post(globals.apiUrl + '/api/MicInvComb/Salvar', micInvComb);
  }

  excluir(idMicroInversor, idProduto) {
    return this.http.delete(globals.apiUrl + '/api/MicInvComb/Excluir',
      { params: new HttpParams().set('idMicroInversor', idMicroInversor).set('idProduto', idProduto) });
  }

  consultarPorIdMicroInversor(idMicroInversor) {
    return this.http.get<any>(globals.apiUrl + '/api/MicInvComb/ListaPorIdMicroInversor',
      { params: new HttpParams().set('idMicroInversor', idMicroInversor) });
  }

  consultar(idMicroInversor, idProduto) {
    return this.http.get<any>(globals.apiUrl + '/api/MicInvComb/Buscar',
      { params: new HttpParams().set('idMicroInversor', idMicroInversor).set('idProduto', idProduto) });
  }

  alterarStatus(idMicroInversor, idProduto, ativo) {
    return this.http.post(globals.apiUrl + '/api/MicInvComb/AlterarStatus', undefined, {
      params: new HttpParams().set('idMicroInversor', idMicroInversor).set('idProduto', idProduto).set('ativo', ativo)
    });
  }
}
